/**
 * The in-memory store.
 *
 * Not a lesser backend and not a test double — it is `StoreEngine` with a patch
 * sink that drops what it is given. Every test in this package runs against the
 * same engine the browser runs, so a behaviour the tests prove is a behaviour
 * the product has, rather than a behaviour of a second implementation that is
 * free to disagree with the first.
 */

import { StoreEngine } from './engine.js';
import { createMemoryPersistence } from './persistence.js';
import type { ObjectStore, StoreOptions } from './store.js';

export function createMemoryStore(o: StoreOptions = {}): ObjectStore {
  // Synchronous: there is nothing to load, and a caller that had to await an
  // empty store would be paying for a network round trip that does not exist.
  return new StoreEngine('memory', createMemoryPersistence(), o);
}
